module.exports = __webpack_public_path__ + "static/media/refer.9d3863a7.svg";